import { ExposedValueGrid as CoreExposedValueGrid, ExposedValueTile as CoreExposedValueTile } from "@/core/components/exposed-values/ExposedValueGrid";
import type {
  ExposedValueDefinition,
  ExposedValueMapping,
  LocationScope,
  RealTimeValue,
} from "@/modules/energy/types";

interface ExposedValueCardProps {
  definition: ExposedValueDefinition;
  mapping: ExposedValueMapping | null;
  realTimeValues: Record<string, RealTimeValue>;
  onSelect: () => void;
  onOpenChart: (mapping: ExposedValueMapping) => void;
  disabled?: boolean;
  compact?: boolean;
}

export const ExposedValueTile = (props: ExposedValueCardProps) => (
  <CoreExposedValueTile translationPrefix="mod_energy.energy_management" {...props} />
);

interface ExposedValueGridProps {
  definitions: ExposedValueDefinition[];
  scope: LocationScope;
  getMapping: (scope: LocationScope, exposedValueId: string) => ExposedValueMapping | null;
  realTimeValues: Record<string, RealTimeValue>;
  onSelect: (definition: ExposedValueDefinition) => void;
  onOpenChart: (mapping: ExposedValueMapping) => void;
  isSelectionDisabled?: boolean;
}

export const ExposedValueGrid = (props: ExposedValueGridProps) => (
  <CoreExposedValueGrid translationPrefix="mod_energy.energy_management" {...props} />
);
